import "./styles.css";
import React, { useCallback, useState } from "react";
import { PieChart, Pie, Cell } from "recharts";

const data = [
  { name: "Group A", value: 400 },
  { name: "Group B", value: 300 },
  { name: "Group C", value: 300 },
  { name: "Group D", value: 200 },
];

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
}) => {
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  const text = document.createElement("text");
  text.setAttribute("x", x);
  text.setAttribute("y", y);
  text.setAttribute("fill", "white");
  text.setAttribute("text-anchor", x > cx ? "start" : "end");
  text.setAttribute("dominant-baseline", "central");
  text.textContent = `${(percent * 100).toFixed(0)}%`;

  return text;
};

export default function PieChartComponent({ children }) {
  return (
    <PieChart width={400} height={400} className="mx-auto">
      {/* <Pie
        data={data}
        cx={200}
        cy={200}
        labelLine={false}
        label={renderCustomizedLabel}
        outerRadius={80}
        fill="#8884d8"
        dataKey="value"
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        ))}
      </Pie> */}
      {children}
    </PieChart>
  );
}
